/**
 * Accor Plus Global file
 * Date Created: 10/07/2022
 */

import { isLocalhost, isProdEnvironment } from "./environments";

const Global = {
  GTM_ID: "GTM-KBDMQM",
  BASE_URL: function () {
    if (isLocalhost()) return "";
    else {
      return "/wp-content/themes/accor-plus/modules/payment-portal/files/";
    }
  },
  IFRAME_URL: function () {
    if (isLocalhost()) return "http://localhost/payment-portal/asiapay";
    else {
      return "/wp-content/themes/accor-plus/modules/payment-portal/files/AsiaPay";
    }
  },
  LOGIN_URL: function () {
    if (!isProdEnvironment())
      return "https://rec-login.accor.com/as/authorization.oauth2?client_id=com.accorplus&response_type=code&persistent=yes&scope=openid+PROFILE.READ+PROFILE.WRITE+PROFILE.WALLET&redirect_uri=https%3A%2F%2Faccorstaging.wpstaging.io%2Fcallback";
    else {
      return "https://login.accor.com/as/authorization.oauth2?client_id=com.accorplus&response_type=code&persistent=yes&scope=openid+PROFILE.READ+PROFILE.WRITE+PROFILE.WALLET&redirect_uri=https%3A%2F%2Fwww.accorplus.com%2Fcallback";
    }
  },
  noOppMsg:
    "Unfortunately you cannot renew your membership at this time. Please <a href='contact'>contact Member Services</a>.",
  personalInfoEditLink: function () {
    if (!isProdEnvironment())
      return "https://rec1-secure.accor.com/account/index.en.shtml#/information/personal";
    else {
      return "https://secure.accor.com/account/index.en.shtml#/information/personal";
    }
  },
  termsAndConditionsObj: function () {
    return {
      link: "https://www.accorplus.com/en-au/about/terms-and-conditions",
      target: "_blank",
      label: "Terms and Conditions",
    };
  },
  privacyPolicyObj: function () {
    return {
      link: "https://www.accorhotels.com/security-certificate/index.en.shtml",
      target: "_blank",
      label: "Privacy Policy",
    };
  },
  renewalLink: "/renewals",
  brandColors: function () {
    return {
      //primary color
      darkblue: "#050033",
      //secondary colors
      red: "#A51E19",
      grey: "#74758C",
      turquoise: "#18A09F",
      orange: "#EC6527",
      black: "#221B1A",
      purple: "#713354",
      lightgreen: "#6A8863",
      bluegrey: "#557B97",
    };
  },
  QBRERROR_MESSAGE: function () {
    return {
      INVALID_INPUT_PARAMETER:
        "Invalid request payload with invalid value details",
      INVALID_INPUT_PARAMETER: "Please provide a valid ABN",
      INVALID_INPUT_PARAMETER: "Please provide a valid ABN",
      EMAIL_ALREADY_REGISTERED: "Please provide a different email address.",
      ABN_ALREADY_REGISTERED:
        "This ABN is already registered in Qantas Business Rewards.",
      INVALID_PROMO_CODE: "Please provide a valid promo code.",
      INTERNAL_SERVER_ERROR:
        "Something's not quite right and Qantas technicians are investigating. Please try again later.",
    };
  },
  SALUTATION_LIST: [
    { value: "Mr", text: "Mr." },
    { value: "Ms", text: "Ms." },
    { value: "Mrs", text: "Mrs." },
    { value: "Doctor", text: "Doctor" },
    { value: "Professor", text: "Professor" },
  ],
  PREFERRED_LANGUAGE: [
    { value: "en", text: "English" },
    { value: "id", text: "Bahasa" },
    { value: "th", text: "Thai / แบบไทย" },
    { value: "vi", text: "Vietnamese / Tiếng Việt" },
    { value: "ko", text: "Korea / 한국" },
  ],
  COUNTRY_LIST: [
    { code: "au", label: "Australia", subsidiary: 16 },
    { code: "cn", label: "China", subsidiary: 14 },
    { code: "fj", label: "Fiji", subsidiary: 17 },
    { code: "hk", label: "Hong Kong", subsidiary: 15 },
    { code: "in", label: "India", subsidiary: 10 },
    { code: "id", label: "Indonesia", subsidiary: 11 },
    { code: "mo", label: "Macau", subsidiary: 23 },
    { code: "my", label: "Malaysia", subsidiary: 12 },
    { code: "nz", label: "New Zealand", subsidiary: 18 },
    { code: "ph", label: "Philippines", subsidiary: 8 },
    { code: "sg", label: "Singapore", subsidiary: 13 },
    { code: "tw", label: "Taiwan" },
    { code: "th", label: "Thailand", subsidiary: 6 },
    { code: "vn", label: "Vietnam", subsidiary: 7 },
    { code: "en", label: "Rest of the World", subsidiary: 26 },
  ],

  /* POSTAL_CODE RULES
    <!-- Numeric only -->
    RegEx: ^\d+$

    <!-- Alphanumeric only -->
    ^[A-Za-z0-9]+$
  */

  POSTAL_CODE_LIST: [
    { code: "nz",  maxLength: 4, required: true, inputMode: 'numeric', regExpressionRules: /[^0-9]/g},  
    { code: "au",  maxLength: 4, required: true, inputMode: 'numeric', regExpressionRules: /[^0-9]/g},
    { code: "in",  maxLength: 6, required: true, inputMode: 'numeric', regExpressionRules: /[^0-9]/g},  
    { code: "id",  maxLength: 5, required: true, inputMode: 'numeric', regExpressionRules: /[^0-9]/g}, 
    { code: "my",  maxLength: 5, required: true, inputMode: 'numeric', regExpressionRules: /[^0-9]/g}, 
    { code: "sg",  maxLength: 6, required: true, inputMode: 'numeric', regExpressionRules: /[^0-9]/g}, 
    { code: "ph",  maxLength: 4, required: true, inputMode: 'numeric', regExpressionRules: /[^0-9]/g}, 
    { code: "th",  maxLength: 5, required: true, inputMode: 'numeric', regExpressionRules: /[^0-9]/g}, 
    { code: "vn",  maxLength: 6, required: true, inputMode: 'numeric', regExpressionRules: /[^0-9]/g}, 
    { code: "hk",  required: false, defaultVal:"0000", regExpressionRules: /[^a-zA-Z0-9 ]/g}, 
    { code: "row", minLength: 3, maxLength: 10, required: true, regExpressionRules: /[^a-zA-Z0-9 ]/g},
  ],

  BILLING_COUNTRY_LIST: [
    "Country",
    "Afghanistan",
    "Albania",
    "Algeria",
    "Andorra",
    "Angola",
    "Anguilla",
    "Antarctica",
    "Antigua and Barbuda",
    "Argentina Republic",
    "Armenia",
    "Aruba",
    "Austria",
    "Australia",
    "Azerbaijan",
    "Bahamas",
    "Bahrain",
    "Bangladesh",
    "Barbados",
    "Belarus",
    "Belgium",
    "Belize",
    "Benin",
    "Bermuda",
    "Bhutan",
    "Botswana",
    "Bouvet Island",
    "Bolivia",
    "Bosnia and Herzegovina",
    "Brazil",
    "British Indian Ocean Territory",
    "British Virgin Islands",
    "Brunei Darussalam",
    "Bulgaria",
    "Burkina Faso",
    "Burundi",
    "Cambodia",
    "Croatia",
    "Cameroon",
    "Canada",
    "Cape Verde",
    "Cayman Islands",
    "Central African Republic",
    "Chile",
    "Christmas Islands",
    "Cocos Islands",
    "Colombia",
    "Comoros",
    "Congo",
    "Cook Islands",
    "Costa Rica",
    "Cote D'Ivoire",
    "Cyprus",
    "Cuba",
    "Czech Republic",
    "Denmark",
    "Djibouti",
    "Dominica",
    "Dominican Republic",
    "East Timor", //*
    "Ecuador",
    "Egypt",
    "El Salvador",
    "Estonia",
    "Equatorial Guinea",
    "Ethiopia",
    "Falkland Islands",
    "Faroe Islands",
    "Finland",
    "France",
    "French Guiana",
    "French Polynesia",
    "French Southern Territories",
    "Gabon",
    "Gambia",
    "Georgia",
    "Germany",
    "Ghana",
    "Gibraltar",
    "Greece",
    "Greenland",
    "Grenada",
    "Guadeloupe",
    "Guam",
    "Guatemala",
    "Guinea",
    "Guinea-Bissau",
    "Guyana",
    "Haiti",
    "Heard and McDonald Islands",
    "Honduras",
    "Hong Kong",
    "Hungary",
    "Iceland",
    "India",
    "Indonesia",
    "Iraq",
    "Iran",
    "Ireland",
    "Israel",
    "Italy",
    "Jamaica",
    "Japan",
    "Jordan",
    "Kazakhstan",
    "Kenya",
    "Kiribati",
    "Korea",
    "Kuwait",
    "Kyrgyzstan",
    "Lao",
    "Latvia",
    "Lebanon",
    "Lesotho",
    "Liberia",
    "Libyan Arab Jamahiriya",
    "Liechtenstein",
    "Lithuania",
    "Luxembourg",
    "Macedonia",
    "Madagascar",
    "Malawi",
    "Malaysia",
    "Maldives",
    "Mali",
    "Malta",
    "Marshall Islands",
    "Martinique",
    "Mauritania",
    "Mauritius",
    "Mayotte",
    "Mexico",
    "Mongolia",
    "Montenegro", //*
    "Montserrat",
    "Morocco",
    "Mozambique",
    "Micronesia",
    "Monaco",
    "Myanmar",
    "Namibia",
    "Nauru",
    "Nepal",
    "Netherlands Antilles", //*
    "The Netherlands",
    "New Caledonia",
    "New Zealand",
    "Nicaragua",
    "Niger",
    "Nigeria",
    "Niue",
    "Norfolk Island",
    "Northern Mariana Islands",
    "Norway",
    "Oman",
    "Panama",
    "Pakistan",
    "Palau",
    "Palestine",
    "Papua New Guinea",
    "Paraguay",
    "Peru",
    "Philippines",
    "Pitcairn",
    "Poland",
    "Portugal",
    "Puerto Rico",
    "Qatar",
    "Romania",
    "Russian Federation",
    "Rwanda",
    "Samoa",
    "San Marino",
    "Sao Tome and Principe",
    "Saudi Arabia",
    "Senegal",
    "Serbia",
    "Seychelles",
    "Sierra Leone",
    "Singapore",
    "Slovakia",
    "Slovenia",
    "Solomon Islands",
    "Somalia",
    "South Africa",
    "Spain",
    "Sri Lanka",
    "St. Helena",
    "St. Kitts and Nevis",
    "St. Lucia",
    "St. Pierre and Miquelon",
    "St. Vincent and the Grenadines",
    "Sudan",
    "Suriname",
    "Svalbard and Jan Mayen",
    "Swaziland",
    "Sweden",
    "Switzerland",
    "Syrian Arab Republic",
    "Tajikistan",
    "Tanzania",
    "Thailand",
    "Togo",
    "Tokelau",
    "Tonga",
    "Trinidad and Tobago",
    "Tunisia",
    "Turkey",
    "Turkmenistan",
    "Tuvalu",
    "Uganda",
    "Ukraine",
    "United Arab Emirates",
    "United Kingdom",
    "United States",
    "U.S. Minor Outlying Islands",
    "Uruguay",
    "Uzbekistan",
    "Vanuatu",
    "Venezuela",
    "Vietnam",
    "Virgin Islands (USA)",
    "Vatican City State",
    "Wallis and Futuna Islands",
    "Western Sahara",
    "Yemen",
    "Yugoslavia", //*
    "Zambia",
    "Zimbabwe",
  ],
  SHIPPING_COUNTRY_LIST: [
    "",
    "Afghanistan",
    "Albania",
    "Algeria",
    "Andorra",
    "Angola",
    "Anguilla",
    "Antarctica",
    "Antigua and Barbuda",
    "Argentina Republic",
    "Armenia",
    "Aruba",
    "Austria",
    "Australia",
    "Azerbaijan",
    "Bahamas",
    "Bahrain",
    "Bangladesh",
    "Barbados",
    "Belarus",
    "Belgium",
    "Belize",
    "Benin",
    "Bermuda",
    "Bhutan",
    "Botswana",
    "Bouvet Island",
    "Bolivia",
    "Bosnia and Herzegovina",
    "Brazil",
    "British Indian Ocean Territory",
    "British Virgin Islands",
    "Brunei Darussalam",
    "Bulgaria",
    "Burkina Faso",
    "Burundi",
    "Cambodia",
    "Croatia",
    "Cameroon",
    "Canada",
    "Cape Verde",
    "Cayman Islands",
    "Central African Republic",
    "Chile",
    "Christmas Islands",
    "Cocos Islands",
    "Colombia",
    "Comoros",
    "Congo",
    "Cook Islands",
    "Costa Rica",
    "Cote D'Ivoire",
    "Cyprus",
    "Cuba",
    "Czech Republic",
    "Denmark",
    "Djibouti",
    "Dominica",
    "Dominican Republic",
    "East Timor",
    "Ecuador",
    "Egypt",
    "El Salvador",
    "Estonia",
    "Equatorial Guinea",
    "Ethiopia",
    "Falkland Islands",
    "Faroe Islands",
    "Finland",
    "France",
    "French Guiana",
    "French Polynesia",
    "French Southern Territories",
    "Gabon",
    "Gambia",
    "Georgia",
    "Germany",
    "Ghana",
    "Gibraltar",
    "Greece",
    "Greenland",
    "Grenada",
    "Guadeloupe",
    "Guam",
    "Guatemala",
    "Guinea",
    "Guinea-Bissau",
    "Guyana",
    "Haiti",
    "Heard and McDonald Islands",
    "Honduras",
    "Hong Kong",
    "Hungary",
    "Iceland",
    "India",
    "Indonesia",
    "Iraq",
    "Iran",
    "Ireland",
    "Israel",
    "Italy",
    "Jamaica",
    "Japan",
    "Jordan",
    "Kazakhstan",
    "Kenya",
    "Kiribati",
    "Korea",
    "Kuwait",
    "Kyrgyzstan",
    "Lao",
    "Latvia",
    "Lebanon",
    "Lesotho",
    "Liberia",
    "Libyan Arab Jamahiriya",
    "Liechtenstein",
    "Lithuania",
    "Luxembourg",
    "Macedonia",
    "Madagascar",
    "Malawi",
    "Malaysia",
    "Maldives",
    "Mali",
    "Malta",
    "Marshall Islands",
    "Martinique",
    "Mauritania",
    "Mauritius",
    "Mayotte",
    "Mexico",
    "Mongolia",
    "Montenegro",
    "Montserrat",
    "Morocco",
    "Mozambique",
    "Micronesia",
    "Monaco",
    "Myanmar",
    "Namibia",
    "Nauru",
    "Nepal",
    "Netherlands Antilles", //*
    "The Netherlands",
    "New Caledonia",
    "New Zealand",
    "Nicaragua",
    "Niger",
    "Nigeria",
    "Niue",
    "Norfolk Island",
    "Northern Mariana Islands",
    "Norway",
    "Oman",
    "Panama",
    "Pakistan",
    "Palau",
    "Palestine",
    "Papua New Guinea",
    "Paraguay",
    "Peru",
    "Philippines",
    "Pitcairn",
    "Poland",
    "Portugal",
    "Puerto Rico",
    "Qatar",
    "Romania",
    "Russian Federation",
    "Rwanda",
    "Samoa",
    "San Marino",
    "Sao Tome and Principe",
    "Saudi Arabia",
    "Senegal",
    "Serbia",
    "Seychelles",
    "Sierra Leone",
    "Singapore",
    "Slovakia",
    "Slovenia",
    "Solomon Islands",
    "Somalia",
    "South Africa",
    "Spain",
    "Sri Lanka",
    "St. Helena",
    "St. Kitts and Nevis",
    "St. Lucia",
    "St. Pierre and Miquelon",
    "St. Vincent and the Grenadines",
    "Sudan",
    "Suriname",
    "Svalbard and Jan Mayen",
    "Swaziland",
    "Sweden",
    "Switzerland",
    "Syrian Arab Republic",
    "Tajikistan",
    "Tanzania",
    "Thailand",
    "Togo",
    "Tokelau",
    "Tonga",
    "Trinidad and Tobago",
    "Tunisia",
    "Turkey",
    "Turkmenistan",
    "Tuvalu",
    "Uganda",
    "Ukraine",
    "United Arab Emirates",
    "United Kingdom",
    "United States",
    "U.S. Minor Outlying Islands",
    "Uruguay",
    "Uzbekistan",
    "Vanuatu",
    "Venezuela",
    "Vietnam",
    "Virgin Islands (USA)",
    "Vatican City State",
    "Wallis and Futuna Islands",
    "Western Sahara",
    "Yemen",
    "Yugoslavia",
    "Zambia",
    "Zimbabwe",
  ],
  CODED_COUNTRY_LIST: [
    { name: "Country", code: "", iso: "" },
    { name: "Afghanistan", code: "AF", iso: "Afghanistan" },
    // {"name": 'Åland Islands', "code": 'AX',"iso": 'Åland Islands'},
    { name: "Albania", code: "AL", iso: "Albania" },
    { name: "Algeria", code: "DZ", iso: "Algeria" },
    // {"name": 'American Samoa', "code": 'AS',"iso": 'American Samoa'},
    { name: "Andorra", code: "AD", iso: "Andorra" },
    { name: "Angola", code: "AO", iso: "Angola" },
    { name: "Anguilla", code: "AI", iso: "Anguilla" },
    { name: "Antarctica", code: "AQ", iso: "Antarctica" },
    { name: "Antigua and Barbuda", code: "AG", iso: "Antigua and Barbuda" },
    { name: "Argentina Republic", code: "AR", iso: "Argentina" },
    { name: "Armenia", code: "AM", iso: "Armenia" },
    { name: "Aruba", code: "AW", iso: "Aruba" },
    { name: "Australia", code: "AU", iso: "Australia" },
    { name: "Austria", code: "AT", iso: "Austria" },
    { name: "Azerbaijan", code: "AZ", iso: "Azerbaijan" },
    { name: "Bahamas", code: "BS", iso: "Bahamas" },
    { name: "Bahrain", code: "BH", iso: "Bahrain" },
    { name: "Bangladesh", code: "BD", iso: "Bangladesh" },
    { name: "Barbados", code: "BB", iso: "Barbados" },
    { name: "Belarus", code: "BY", iso: "Belarus" },
    { name: "Belgium", code: "BE", iso: "Belgium" },
    { name: "Belize", code: "BZ", iso: "Belize" },
    { name: "Benin", code: "BJ", iso: "Benin" },
    { name: "Bermuda", code: "BM", iso: "Bermuda" },
    { name: "Bhutan", code: "BT", iso: "Bhutan" },
    { name: "Bolivia", code: "BO", iso: "Bolivia (Plurinational State of)" },
    {
      name: "Bosnia and Herzegovina",
      code: "BA",
      iso: "Bosnia and Herzegovina",
    },
    { name: "Botswana", code: "BW", iso: "Botswana" },
    { name: "Bouvet Island", code: "BV", iso: "Bouvet Island" },
    { name: "Brazil", code: "BR", iso: "Brazil" },
    {
      name: "British Indian Ocean Territory",
      code: "IO",
      iso: "British Indian Ocean Territory (the)",
    },
    {
      name: "British Virgin Islands",
      code: "VG",
      iso: "Virgin Islands (British)",
    },
    { name: "Brunei Darussalam", code: "BN", iso: "Brunei Darussalam" },
    { name: "Bulgaria", code: "BG", iso: "Bulgaria" },
    { name: "Burkina Faso", code: "BF", iso: "Burkina Faso" },
    { name: "Burundi", code: "BI", iso: "Burundi" },
    { name: "Cambodia", code: "KH", iso: "Cambodia" },
    { name: "Cameroon", code: "CM", iso: "Cameroon" },
    { name: "Canada", code: "CA", iso: "Canada" },
    { name: "Cape Verde", code: "CV", iso: "Cabo Verde" },
    { name: "Cayman Islands", code: "KY", iso: "Cayman Islands (the)" },
    {
      name: "Central African Republic",
      code: "CF",
      iso: "Central African Republic (the)",
    },
    // {"name": 'Chad', "code": 'TD',"iso": 'Chad'},
    { name: "Chile", code: "CL", iso: "Chile" },
    { name: "China", code: "CN", iso: "China" },
    { name: "Christmas Islands", code: "CX", iso: "Christmas Island" },
    { name: "Cocos Islands", code: "CC", iso: "Cocos (Keeling) Islands (the)" },
    { name: "Colombia", code: "CO", iso: "Colombia" },
    { name: "Comoros", code: "KM", iso: "Comoros" },
    { name: "Congo", code: "CG", iso: "Congo (the)" },
    // {"name": 'Congo, The Democratic Republic of the', "code": 'CD',"iso": 'Congo (the Democratic Republic of the)'},
    { name: "Cook Islands", code: "CK", iso: "Cook Islands (the)" },
    { name: "Costa Rica", code: "CR", iso: "Costa Rica" },
    { name: "Cote D'Ivoire", code: "CI", iso: "Côte d'Ivoire" },
    { name: "Croatia", code: "HR", iso: "Croatia" },
    { name: "Cuba", code: "CU", iso: "Cuba" },
    { name: "Cyprus", code: "CY", iso: "Cyprus" },
    { name: "Czech Republic", code: "CZ", iso: "Czechia" },
    { name: "Denmark", code: "DK", iso: "Denmark" },
    { name: "Djibouti", code: "DJ", iso: "Djibouti" },
    { name: "Dominica", code: "DM", iso: "Dominica" },
    { name: "Dominican Republic", code: "DO", iso: "Dominican Republic (the)" },
    { name: "Ecuador", code: "EC", iso: "Ecuador" },
    { name: "Egypt", code: "EG", iso: "Egypt" },
    { name: "El Salvador", code: "SV", iso: "El Salvador" },
    { name: "Equatorial Guinea", code: "GQ", iso: "Equatorial Guinea" },
    { name: "Eritrea", code: "ER", iso: "Eritrea" }, //*
    { name: "Estonia", code: "EE", iso: "Estonia" },
    { name: "Ethiopia", code: "ET", iso: "Ethiopia" },
    { name: "Falkland Islands", code: "FK", iso: "Falkland Islands (the)" },
    { name: "Faroe Islands", code: "FO", iso: "Faroe Islands (the)" },
    { name: "Fiji", code: "FJ", iso: "Fiji" }, //*
    { name: "Finland", code: "FI", iso: "Finland" },
    { name: "France", code: "FR", iso: "France" },
    { name: "French Guiana", code: "GF", iso: "French Guiana" },
    { name: "French Polynesia", code: "PF", iso: "French Polynesia" },
    {
      name: "French Southern Territories",
      code: "TF",
      iso: "French Southern Territories (the)",
    },
    { name: "Gabon", code: "GA", iso: "Gabon" },
    { name: "Gambia", code: "GM", iso: "Gambia" },
    { name: "Georgia", code: "GE", iso: "Georgia" },
    { name: "Germany", code: "DE", iso: "Germany" },
    { name: "Ghana", code: "GH", iso: "Ghana" },
    { name: "Gibraltar", code: "GI", iso: "Gibraltar" },
    { name: "Greece", code: "GR", iso: "Greece" },
    { name: "Greenland", code: "GL", iso: "Greenland" },
    { name: "Grenada", code: "GD", iso: "Grenada" },
    { name: "Guadeloupe", code: "GP", iso: "Guadeloupe" },
    { name: "Guam", code: "GU", iso: "Guam" },
    { name: "Guatemala", code: "GT", iso: "Guatemala" },
    { name: "Guernsey", code: "GG", iso: "Guernsey" },
    { name: "Guinea", code: "GN", iso: "Guinea" },
    { name: "Guinea-Bissau", code: "GW", iso: "Guinea-Bissau" },
    { name: "Guyana", code: "GY", iso: "Guyana" },
    { name: "Haiti", code: "HT", iso: "Haiti" },
    {
      name: "Heard and McDonald Islands",
      code: "HM",
      iso: "Heard Island and McDonald Islands",
    },
    // {"name": 'Holy See (Vatican City State)', "code": 'VA',"iso": 'Holy See'},
    { name: "Honduras", code: "HN", iso: "Honduras" },
    { name: "Hong Kong", code: "HK", iso: "Hong Kong" },
    { name: "Hungary", code: "HU", iso: "Hungary" },
    { name: "Iceland", code: "IS", iso: "Iceland" },
    { name: "India", code: "IN", iso: "India" },
    { name: "Indonesia", code: "ID", iso: "Indonesia" },
    { name: "Iran", code: "IR", iso: "Iran (Islamic Republic of)" },
    { name: "Iraq", code: "IQ", iso: "Iraq" },
    { name: "Ireland", code: "IE", iso: "Ireland" },
    // {"name": 'Isle of Man', "code": 'IM',"iso": 'Isle of Man'},
    { name: "Israel", code: "IL", iso: "Israel" },
    { name: "Italy", code: "IT", iso: "Italy" },
    { name: "Jamaica", code: "JM", iso: "Jamaica" },
    { name: "Japan", code: "JP", iso: "Japan" },
    // {"name": 'Jersey', "code": 'JE',"iso": 'Jersey'},        //*
    { name: "Jordan", code: "JO", iso: "Jordan" },
    { name: "Kazakhstan", code: "KZ", iso: "Kazakhstan" },
    { name: "Kenya", code: "KE", iso: "Kenya" },
    { name: "Kiribati", code: "KI", iso: "Kiribati" },
    // {"name": 'Korea, Democratic People\'S Republic of', "code": 'KP',"iso": 'Korea (the Democratic People\'s Republic of)'},  //*
    // {"name": 'Korea', "code": 'KR',"iso": 'Korea'},
    { name: "Korea, Republic of", code: "KR", iso: "Korea (the Republic of)" },
    { name: "Kuwait", code: "KW", iso: "Kuwait" },
    { name: "Kyrgyzstan", code: "KG", iso: "Kyrgyzstan" },
    { name: "Lao", code: "LA", iso: "Lao People's Democratic Republic (the)" },
    { name: "Latvia", code: "LV", iso: "Latvia" },
    { name: "Lebanon", code: "LB", iso: "Lebanon" },
    { name: "Lesotho", code: "LS", iso: "Lesotho" },
    { name: "Liberia", code: "LR", iso: "Liberia" },
    { name: "Libyan Arab Jamahiriya", code: "LY", iso: "Libya" },
    { name: "Liechtenstein", code: "LI", iso: "Liechtenstein" },
    { name: "Lithuania", code: "LT", iso: "Lithuania" },
    { name: "Luxembourg", code: "LU", iso: "Luxembourg" },
    { name: "Macao", code: "MO", iso: "Macao" },
    {
      name: "Macedonia, The Former Yugoslav Republic of",
      code: "MK",
      iso: "North Macedonia",
    },
    { name: "Madagascar", code: "MG", iso: "Madagascar" },
    { name: "Malawi", code: "MW", iso: "Malawi" },
    { name: "Malaysia", code: "MY", iso: "Malaysia" },
    { name: "Maldives", code: "MV", iso: "Maldives" },
    { name: "Mali", code: "ML", iso: "Mali" },
    { name: "Malta", code: "MT", iso: "Malta" },
    { name: "Marshall Islands", code: "MH", iso: "Marshall Islands (the)" },
    { name: "Martinique", code: "MQ", iso: "Martinique" },
    { name: "Mauritania", code: "MR", iso: "Mauritania" },
    { name: "Mauritius", code: "MU", iso: "Mauritius" },
    { name: "Mayotte", code: "YT", iso: "Mayotte" },
    { name: "Mexico", code: "MX", iso: "Mexico" },
    { name: "Micronesia", code: "FM", iso: "Micronesia (Federated States of)" },
    // {"name": 'Moldova, Republic of', "code": 'MD',"iso": 'Moldova (the Republic of)'},   //*
    { name: "Monaco", code: "MC", iso: "Monaco" },
    { name: "Mongolia", code: "MN", iso: "Mongolia" },
    { name: "Montserrat", code: "MS", iso: "Montserrat" },
    { name: "Morocco", code: "MA", iso: "Morocco" },
    { name: "Mozambique", code: "MZ", iso: "Mozambique" },
    { name: "Myanmar", code: "MM", iso: "Myanmar" },
    { name: "Namibia", code: "NA", iso: "Namibia" },
    { name: "Nauru", code: "NR", iso: "Nauru" },
    { name: "Nepal", code: "NP", iso: "Nepal" },
    { name: "The Netherlands", code: "NL", iso: "Netherlands (the)" },
    { name: "New Caledonia", code: "NC", iso: "New Caledonia" },
    { name: "New Zealand", code: "NZ", iso: "New Zealand" },
    { name: "Nicaragua", code: "NI", iso: "Nicaragua" },
    { name: "Niger", code: "NE", iso: "Niger" },
    { name: "Nigeria", code: "NG", iso: "Nigeria" },
    { name: "Niue", code: "NU", iso: "Niue" },
    { name: "Norfolk Island", code: "NF", iso: "Norfolk Island" },
    {
      name: "Northern Mariana Islands",
      code: "MP",
      iso: "Northern Mariana Islands (the)",
    },
    { name: "Norway", code: "NO", iso: "Norway" },
    { name: "Oman", code: "OM", iso: "Oman" },
    { name: "Pakistan", code: "PK", iso: "Pakistan" },
    { name: "Palau", code: "PW", iso: "Palau" },
    { name: "Palestine", code: "PS", iso: "Palestine, State of" },
    { name: "Panama", code: "PA", iso: "Panama" },
    { name: "Papua New Guinea", code: "PG", iso: "Papua New Guinea" },
    { name: "Paraguay", code: "PY", iso: "Paraguay" },
    { name: "Peru", code: "PE", iso: "Peru" },
    { name: "Philippines", code: "PH", iso: "Philippines" },
    { name: "Pitcairn", code: "PN", iso: "Pitcairn" },
    { name: "Poland", code: "PL", iso: "Poland" },
    { name: "Portugal", code: "PT", iso: "Portugal" },
    { name: "Puerto Rico", code: "PR", iso: "Puerto Rico" },
    { name: "Qatar", code: "QA", iso: "Qatar" },
    // {"name": 'Reunion', "code": 'RE',"iso": 'Réunion'},  //*
    { name: "Romania", code: "RO", iso: "Romania" },
    { name: "Russian Federation", code: "RU", iso: "Russian Federation" },
    { name: "Rwanda", code: "RW", iso: "Rwanda" },
    {
      name: "St. Helena",
      code: "SH",
      iso: "Saint Helena, Ascension and Tristan da Cunha",
    },
    { name: "St. Kitts and Nevis", code: "KN", iso: "Saint Kitts and Nevis" },
    { name: "St. Lucia", code: "LC", iso: "Saint Lucia" },
    {
      name: "St. Pierre and Miquelon",
      code: "PM",
      iso: "Saint Pierre and Miquelon",
    },
    {
      name: "St. Vincent and the Grenadines",
      code: "VC",
      iso: "Saint Vincent and the Grenadines",
    },
    { name: "Samoa", code: "WS", iso: "Samoa" },
    { name: "San Marino", code: "SM", iso: "San Marino" },
    { name: "Sao Tome and Principe", code: "ST", iso: "Sao Tome and Principe" },
    { name: "Saudi Arabia", code: "SA", iso: "Saudi Arabia" },
    { name: "Senegal", code: "SN", iso: "Senegal" },
    { name: "Serbia", code: "CS", iso: "Serbia" },
    { name: "Seychelles", code: "SC", iso: "Seychelles" },
    { name: "Sierra Leone", code: "SL", iso: "Sierra Leone" },
    { name: "Singapore", code: "SG", iso: "Singapore" },
    { name: "Slovakia", code: "SK", iso: "Slovakia" },
    { name: "Slovenia", code: "SI", iso: "Slovenia" },
    { name: "Solomon Islands", code: "SB", iso: "Solomon Islands" },
    { name: "Somalia", code: "SO", iso: "Somalia" },
    { name: "South Africa", code: "ZA", iso: "South Africa" },
    // {"name": 'South Georgia and the South Sandwich Islands', "code": 'GS',"iso": 'South Georgia and the South Sandwich Islands'},
    { name: "Spain", code: "ES", iso: "Spain" },
    { name: "Sri Lanka", code: "LK", iso: "Sri Lanka" },
    { name: "Sudan", code: "SD", iso: "Sudan" },
    { name: "Suriname", code: "SR", iso: "Suriname" },
    {
      name: "Svalbard and Jan Mayen",
      code: "SJ",
      iso: "Svalbard and Jan Mayen",
    },
    { name: "Swaziland", code: "SZ", iso: "Eswatini" },
    { name: "Sweden", code: "SE", iso: "Sweden" },
    { name: "Switzerland", code: "CH", iso: "Switzerland" },
    {
      name: "Syrian Arab Republic",
      code: "SY",
      iso: "Syrian Arab Republic (the)",
    },
    { name: "Taiwan", code: "TW", iso: "Taiwan" }, //*
    { name: "Tajikistan", code: "TJ", iso: "Tajikistan" },
    {
      name: "Tanzania, United Republic of",
      code: "TZ",
      iso: "Tanzania, the United Republic of",
    },
    { name: "Thailand", code: "TH", iso: "Thailand" },
    { name: "East Timor", code: "TL", iso: "Timor-Leste" },
    { name: "Togo", code: "TG", iso: "Togo" },
    { name: "Tokelau", code: "TK", iso: "Tokelau" },
    { name: "Tonga", code: "TO", iso: "Tonga" },
    { name: "Trinidad and Tobago", code: "TT", iso: "Trinidad and Tobago" },
    { name: "Tunisia", code: "TN", iso: "Tunisia" },
    { name: "Turkey", code: "TR", iso: "Turkey" },
    { name: "Turkmenistan", code: "TM", iso: "Turkmenistan" },
    // {"name": 'Turks and Caicos Islands', "code": 'TC',"iso": 'Turks and Caicos Islands (the)'},
    { name: "Tuvalu", code: "TV", iso: "Tuvalu" },
    { name: "Uganda", code: "UG", iso: "Uganda" },
    { name: "Ukraine", code: "UA", iso: "Ukraine" },
    {
      name: "United Arab Emirates",
      code: "AE",
      iso: "United Arab Emirates (the)",
    },
    {
      name: "United Kingdom",
      code: "GB",
      iso: "United Kingdom of Great Britain and Northern Ireland (the)",
    },
    {
      name: "United States",
      code: "US",
      iso: "United States of America (the)",
    },
    {
      name: "U.S. Minor Outlying Islands",
      code: "UM",
      iso: "United States Minor Outlying Islands (the)",
    },
    { name: "Uruguay", code: "UY", iso: "Uruguay" },
    { name: "Uzbekistan", code: "UZ", iso: "Uzbekistan" },
    { name: "Vanuatu", code: "VU", iso: "Vanuatu" },
    {
      name: "Venezuela",
      code: "VE",
      iso: "Venezuela (Bolivarian Republic of)",
    },
    { name: "Vietnam", code: "VN", iso: "Viet Nam" },
    // {"name": 'Virgin Islands, British', "code": 'VG',"iso": 'Virgin Islands (British)'},
    { name: "Virgin Islands (USA)", code: "VI", iso: "Virgin Islands (U.S.)" },
    { name: "Vatican City State", code: "VA", iso: "Holy See" },
    { name: "Wallis and Futuna Islands", code: "WF", iso: "Wallis and Futuna" },
    { name: "Western Sahara", code: "EH", iso: "Western Sahara" },
    { name: "Yemen", code: "YE", iso: "Yemen" },
    { name: "Zambia", code: "ZM", iso: "Zambia" },
    { name: "Zimbabwe", code: "ZW", iso: "Zimbabwe" },
  ],
};

export default Global;
